import type { CatalogUerBaseCostHistoryData } from 'gql/graphql';
import { Button, IconExpand } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useState } from 'react';

import { CatalogUerBaseCostPriceHistory } from '../../CatalogUerBaseCostPriceHistory';

interface IMenuCellRenderer extends ICellRendererParams<CatalogUerBaseCostHistoryData> {
    catalogId: string | undefined;
}

export const MenuCellRenderer = (props: IMenuCellRenderer) => {
    const { data, catalogId } = props;

    const [isDetailsOpened, setIsDetailsOpened] = useState(false);

    const toggleDetailsModal = useCallback(() => {
        setIsDetailsOpened((p) => !p);
    }, []);

    return (
        <>
            {data?.catalogUERBaseCostChange?.hasWorkScopesHistory ? (
                <Button iconLeft={IconExpand} onlyIcon view="clear" size="xs" onClick={toggleDetailsModal} />
            ) : null}

            {catalogId && isDetailsOpened && (
                <CatalogUerBaseCostPriceHistory
                    catalogId={catalogId}
                    catalogPriceName={data?.uerBaseCostCode}
                    historyRecordId={data?.id}
                    onClose={toggleDetailsModal}
                />
            )}
        </>
    );
};
MenuCellRenderer.displayName = 'MenuCellRenderer';
